'use strict';

import Api from "./Api";

export default class ClientStatus extends Api {

    static getList( clientId, page, perPage,sort = undefined) {
        const url = this.url + 'client-status/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                client_id: clientId,
                sort: sort,
            },
        });
    }

}